import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, LOGO_URL } from "@/lib/api";
import { useAdminAuth } from "@/lib/adminAuth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data);
      toast.success(`Welcome back, ${data.name}`);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-md bg-[#141417] border border-[#27272A] px-4 py-3.5 text-white placeholder-zinc-500 outline-none focus:border-[#D4AF37]";

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="ABE" className="h-12 mx-auto logo-invert" />
          <p className="font-oswald text-xs tracking-widest text-zinc-500 mt-3">STAFF & ADMIN PORTAL</p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" type="email" required placeholder="Email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" required placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={loading} className="btn-gold w-full rounded-md py-3.5 font-oswald tracking-widest disabled:opacity-60">
            {loading ? "SIGNING IN…" : "SIGN IN"}
          </button>
          <button type="button" data-testid="forgot-password-link" onClick={() => navigate("/admin/forgot-password")} className="w-full text-center text-xs text-zinc-500 hover:text-[#D4AF37] mt-1">
            Forgot your password?
          </button>
        </form>
      </div>
    </div>
  );
}
